<template>
  <v-container grid-list-xl class="px-5">
    <m-card-list
      two-line
      title="Kelola Akses"
      search
      :add="false"
      :items="items"
      :headers="headers"
      refresh
      @refresh="load"
      :page="page"
      footer
      @search="search"
      @change:page="
            (pg) => {
              cp = pg
              load()
            }
          "
    >
      <template v-slot:items="{ props, item }">
        <tr>
          <td>{{ pVal(item, 'no_reg') }}</td>
          <td>{{ pVal(item, 'nama') }}</td>
          <td>
            <m-menu left style="float:right" :items="more_menu" :object="item" />
          </td>
        </tr>
      </template>
    </m-card-list>
    <ChangeDlg ref="dlg" :tenants="tenants" />
  </v-container>
</template>

<script>
import ChangeDlg from '../components/Form.vue'
import BlockCard from '@/components/BlockCard'

export default {
  components: {
    ChangeDlg,
    BlockCard,
  },
  data() {
    return {
      items: [],
      page: null,
      cp: 1,
      tenants: [],
      headers: [
        { text: 'No Reg', align: 'left', value: 'no_reg' },
        { text: 'Tenant', align: 'left', value: 'nama' },
        { text: 'Aksi', sortable: false },
      ],
      more_menu: [
        {
          title: 'Detail',
          click: (i, o) => this.detail(o),
        },
        {
          title: 'Ubah',
          click: (i, o) => this.edit(o),
        },
      ],
    }
  },
  computed: {},
  mounted() {
    this.load()
    this.loadAll()
  },
  methods: {
    load() {
      this.$store
        .dispatch('tenant/get', { page: this.cp })
        .then((res) => {
          this.page = res.data
          this.items = res.data.data
        })
        .catch((e) => e)
    },
    loadAll() {
      this.$store
        .dispatch('tenant/get', { count: 100 })
        .then((res) => {
          this.tenants = (res.data.data) || (res.data) || []
        })
        .catch((e) => e)
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.load()
      })
    },
    edit(item) {
      this.$refs.dlg.open(item)
    },
    search(textSearch) {
      this.$store
        .dispatch('akses/get', { page: this.cp, search: textSearch })
        .then((res) => {
          // this.page = res.data;
          this.items = res.data.data
        })
        .catch((e) => e)
    },
    hapus(item) {
      this.$confirmDanger(
        `<div class="px-5 mx-1 mt-2 py-2 mb-4 pa-1 row red lighten-5 rounded red--text">

            <i class="v-icon v-alert__icon mdi mdi-information red--text"></i>

            <div class="col py-0 body-2">
            Pastikan Anda benar-benar mengerti apa yang Anda lakukan.
          </div>
        </div>

        Apakah Anda yakin akan menghapus data ini ?<br>
        <div class="mt-2 title grow text-center">
         ${item.keterangan}<br>
        </div>

      `
      )
        .then(() => this.$store.dispatch('akses/drop', item.hari_libur_id))
        .then(() => {
          this.$info('Data berhasil dihapus')
        })
        .then(() => this.load())
        .catch((e) => e)
    },
    ajukan(item) {
      const tanggal = this.$options.filters.toD(item.tanggal)
      this.$confirmDanger(
        `Apakah Anda yakin akan mengajukan data ini ?<br>
        <div class="mt-2 title grow text-center">
          IZIN ${item.keterangan} pada Hari ${tanggal}<br>
        </div>
      `
      )
        // .then(() => this.$store.dispatch("akses/drop", item.hari_libur_id))
        .then(() => {
          this.$info('Data berhasil diajukan')
        })
        .then(() => this.load())
        .catch((e) => e)
    },
    setujui(item) {
      const tanggal = this.$options.filters.toD(item.tanggal)
      this.$confirmDanger(
        `Apakah Anda yakin akan menyetujui data ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama} ${item.jenis} : ${item.keterangan}<br>
          pada Hari ${tanggal}
        </div>
      `,
        {
          keterangan: 'keterangan',
        }
      )
        // .then(() => this.$store.dispatch("akses/drop", item.hari_libur_id))
        .then(() => {
          this.$info('Data berhasil disetujui')
        })
        .then(() => this.load())
        .catch((e) => e)
    },
    tolak(item) {
      const tanggal = this.$options.filters.toD(item.tanggal)
      this.$confirmDanger(
        `Apakah Anda yakin akan menolak data ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama} ${item.jenis} : ${item.keterangan}<br>
          pada Hari ${tanggal}
        </div>
      `,
        {
          keterangan: 'keterangan',
        }
      )
        // .then(() => this.$store.dispatch("akses/drop", item.hari_libur_id))
        .then(() => {
          this.$info('Data berhasil ditolak')
        })
        .then(() => this.load())
        .catch((e) => e)
    },
    detail(item) {
      this.$router.push({ name: 'akses.detail', params: { tenant_id: item.tenant_id } })
    },
  },
}
</script>
